var _defs, _path, _polygon, _polyline, _path2, _circle, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgELearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#1292ee;}.cls-1,.cls-2{fill:none;stroke-miterlimit:10;}.cls-3{fill:#1292ee;}.cls-2{stroke:#0094ef;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.15,69.7c-.16-.26-.37-.66-.5-1.2-.13-.53-.13-.98-.1-1.29.11-.78.8-1.32,1.5-1.24.57.06,1.06.53,1.18,1.15.05.29.1.83-.09,1.47-.19.66-.54,1.09-.74,1.31-.12.16-.31.37-.57.57-.33.25-.64.38-.86.45.08-.12.25-.4.26-.78,0-.18-.03-.33-.07-.44Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.84 39.79 47.86 25.13 86.87 39.79 50 53.83 10.84 39.79"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "50 39.48 67.8 47.05 67.8 63.77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.91,44.12v25.05c4.92,2.31,13.04,5.36,23.46,5.91,13.94.73,24.71-3.4,30.06-5.91v-25.05"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50,
    cy: 50,
    r: 47.68
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 29.16,
    y1: 63.09,
    x2: 38.77,
    y2: 63.09
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgELearning);
export default __webpack_public_path__ + "static/media/E-Learning.ed2c3dda9b185068682326687a331f1a.svg";
export { ForwardRef as ReactComponent };